import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Läuft für ein Ausbildungs-Bundle gerade die befristete Frühbucher-Aktion?
 *
 * Die Antwort kommt ausschließlich vom Server: `create-bundle-checkout`
 * entscheidet mit `action: "detect_tariff"` anhand der SERVERZEIT
 * (`_shared/fruehbucher-aktion.ts`). Bewusst nicht im Browser nachgerechnet —
 * eine verstellte Uhr würde sonst einen Rabatt anzeigen, den der Checkout
 * hinterher nicht einlöst.
 *
 * Solange die Antwort aussteht oder ausbleibt, ist `false` das richtige
 * Ergebnis: dann steht der reguläre Preis da. Lieber kurz zu teuer als ein
 * Versprechen, das die Kasse nicht hält.
 */
export function useAktionsstatus(bundleId: string | null | undefined): boolean {
  const { data } = useQuery({
    queryKey: ["aktionsstatus", bundleId],
    enabled: !!bundleId,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await supabase.functions.invoke("create-bundle-checkout", {
        body: { action: "detect_tariff", bundle_id: bundleId },
      });
      if (error) throw error;
      const aktion = (data as { aktion?: { aktiv?: boolean } } | null)?.aktion;
      return aktion?.aktiv === true;
    },
  });
  return data === true;
}
